const OSS = require('ali-oss')
export const client = new OSS({
    accessKeyId: 'LTAI5tSVcQcxCLCPnoPDV5EF', // 查看你自己的阿里云KEY
    accessKeySecret: 'uMn9nq1kmwZRFtNBhhnj4cMbDlSL2D', // 查看自己的阿里云KEYSECRET
    bucket: 'xmitech-china', // 你的 OSS bucket 名称
    region: 'oss-cn-shenzhen', // bucket 所在地址
    cname: false, // 开启自定义域名上传
    endpoint: 'oss-cn-shenzhen.aliyuncs.com' // 自己的域名
})
